import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Entitytag } from '@src/app/models/entitytag';
import { Tag } from '@src/app/models/tag';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagaddremoveService {

  constructor(private http:HttpClient) { }

  //Get list of available tag
  //GET	    /organization/{organizationId}/tag/list/type/{tagtype}
  getTags(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag/list',httpOptions);
  }


  //Add new tag
  //POST	    /organization/{organizationId}/tag
  saveTag(tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/tag',tag,httpOptions);
  }

  //Get tags for a specific entity
  //GET	    /entity/{entityId}/entitytag/list/type/{tagtype}
  getEntityTags(entityId:string,tagtype:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/entity/'+entityId+'/entitytag/list/type/'+tagtype,httpOptions);
  }

  //Add a tag to an entity
  //PUT	    /entity/{entityId}/entitytag/{tagId}
  addTagToEntity(entityId:string,tag:Tag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/entity/'+entityId+'/entitytag/'+tag.tagId,tag,httpOptions);
  }

  //Remove tag from entity
  //DELETE	/entity/{entityId}/entitytag/{tagId}
  removeTagFromEntity(etag:Entitytag){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/entity/'+etag.entityId+'/entitytag/'+etag.tagId,httpOptions);
  }
}
